/* eslint-disable max-len */
import 'react';

const SidebarLocalPDFSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        fill="currentColor"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h16v16H0z" />
            <path
                d="M8.53 7.185c-.058.69-.672 2.687-1.125 3.398-.629.988-1.89 1.815-2.355 1.213-.723-.936 1.114-1.572 2.931-1.852 1.376-.212 2.78-.477 3.074.218.295.695-.632 1.215-1.436.663-.741-.509-2.06-2.285-2.444-3.265-.62-1.587 1.476-1.825 1.355-.375z"
                stroke="currentColor"
                strokeWidth={0.756}
                strokeLinecap="round"
                strokeDasharray="0,0"
            />
            <path
                d="M13.334 5.891v7.087c0 .687-.557 1.244-1.244 1.244H3.91a1.244 1.244 0 01-1.244-1.244V3.467c0-.688.557-1.245 1.244-1.245h5.825"
                stroke="currentColor"
                strokeWidth={0.889}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="0,0"
            />
            <path
                d="M13.333 5.778h-2.31a1.244 1.244 0 01-1.245-1.245v-2.31h0l3.555 3.555z"
                stroke="currentColor"
                strokeWidth={0.889}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="0,0"
            />
        </g>
    </svg>
);
export default SidebarLocalPDFSvg;
